import Skeleton from "react-loading-skeleton";
import { FiRefreshCw } from "react-icons/fi";
import type { ProductQuery } from "../../../__generated__/graphql";

type Product = ProductQuery["product"];

interface ProductHeaderProps {
  product: Product | null | undefined;
  loading: boolean;
  isRefreshing: boolean;
  onRefresh: () => void;
}

const ProductHeader = ({
  product,
  loading,
  isRefreshing,
  onRefresh,
}: ProductHeaderProps) => {
  return (
    <div className="px-4 py-3">
      <div className="flex flex-col mb-3 space-y-2">
        {loading ? (
          <Skeleton style={{ height: 31, width: 80 }} />
        ) : (
          <h2 className="text-3xl font-semibold text-black">
            {product?.name}
          </h2>
        )}
        <div className="flex items-center space-x-2 mt-1">
          <span className="text-sm font-medium text-[#1569fc]">
            {product?.currentCount !== undefined && product.currentCount < 0
              ? 0
              : product?.currentCount}
            개 남았어요!
          </span>
          <button
            onClick={onRefresh}
            className={`p-1 rounded-full hover:bg-gray-100 transition-colors ${
              isRefreshing ? "animate-spin" : ""
            }`}
            aria-label="재고 새로고침"
          >
            <FiRefreshCw className="text-gray-500 w-4 h-4" />
          </button>
        </div>
        {product?.isSampleMenu && (
          <div className="flex flex-col items-start space-y-1">
            <div className="text-sm text-pink-500 font-semibold">
              이벤트 메뉴
            </div>
            <p className="text-sm text-gray-600">
              이 메뉴는 마감상품이 아닌 사장님께서 이벤트로 할인 하는
              메뉴예요!
            </p>
          </div>
        )}
        <div className="flex items-center"></div>
      </div>
      <div className="flex items-center text-md">
        {product?.description}
      </div>
    </div>
  );
};

export default ProductHeader;
